// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { UserModel } from '../../../../app/models/users/user';
import { Adapter } from './adapter';

/**
 * Zugriff auf den aktuell angemeldeten Benutzer.
 */
export class UserAdapter extends Adapter {
  /**
   * Aktuell angemeldeter Benutzer (aus dem UserHelper).
   *
   * @returns Der aktive Benutzer.
   */
  public getCurrent(): UserModel | undefined {
    return this.services.userHelper.getUser(true);
  }
}